/**
 * Hooks for the rank ladder's points thresholds.
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { rankThresholdsApi } from '@api/endpoints/rankThresholds'
import type { RankThresholdsResponse, UpdateRankThresholdsRequest } from '@api/types/rankThresholds'

const RANK_THRESHOLDS_KEY = ['rank-thresholds']

/** The ladder, its defaults and who last changed each rung. */
export function useRankThresholds() {
  return useQuery({
    queryKey: RANK_THRESHOLDS_KEY,
    queryFn: () => rankThresholdsApi.get(),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  })
}

export function useUpdateRankThresholds() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: UpdateRankThresholdsRequest) => rankThresholdsApi.update(request),
    onSuccess: (data: RankThresholdsResponse) => {
      // The PUT returns the full fresh payload, so seed the cache rather than refetch.
      queryClient.setQueryData(RANK_THRESHOLDS_KEY, data)
    },
  })
}

export function useResetRankThresholds() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => rankThresholdsApi.reset(),
    onSuccess: (data: RankThresholdsResponse) => {
      queryClient.setQueryData(RANK_THRESHOLDS_KEY, data)
    },
  })
}
